import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BtnLoadingComponent } from './btn-loading/btn-loading.component';
import { FeatherIconComponent } from './feather-icon/feather-icon.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { BlankLayoutComponent } from './layouts/blank-layout/blank-layout.component';
import { StudentLayoutComponent } from './layouts/student-layout/student-layout.component';
import { TeacherLayoutComponent } from './layouts/teacher-layout/teacher-layout.component';
import { ReportLayoutComponent } from './layouts/report-layout/report-layout.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { SharedPipesModule } from '../pipes/shared-pipes.module';
import { SearchModule } from './search/search.module';
import { SharedDirectivesModule } from '../directives/shared-directives.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { FooterComponent } from './footer/footer.component';
import { TableComponent, TitleCasePipe } from './table/table.component';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { DatePipe } from '@angular/common';
import { from } from 'rxjs';
import { NoRightClickDirective } from './no-right-click.directive';

import { PreviewQuestionComponent } from 'src/app/shared/components/preview-question/preview-question.component';
import { ReviewQuestionComponent } from 'src/app/shared/components/review-question/review-question.component';
import { LightboxModule } from 'ngx-lightbox';

const components = [
  BtnLoadingComponent,
  FeatherIconComponent,
  HeaderComponent,
  SidebarComponent,
  FooterComponent,
  AdminLayoutComponent,
  AuthLayoutComponent,
  BlankLayoutComponent,
  StudentLayoutComponent,
  TeacherLayoutComponent,
  ReportLayoutComponent,
  TitleCasePipe,
  TableComponent,
  NoRightClickDirective,
  PreviewQuestionComponent,
  ReviewQuestionComponent
]

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SharedPipesModule,
    SharedDirectivesModule,
    SearchModule,
    PerfectScrollbarModule,
    NgbModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatIconModule,
    LightboxModule
  ],
  providers: [DatePipe],
  declarations: components,
  exports: components
})
export class SharedComponentsModule { }
